import { render, staticRenderFns } from "./TeamAnswer.vue?vue&type=template&id=2333a6c6&scoped=true"
import script from "./TeamAnswer.vue?vue&type=script&lang=js"
export * from "./TeamAnswer.vue?vue&type=script&lang=js"
import style0 from "./TeamAnswer.vue?vue&type=style&index=0&id=2333a6c6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2333a6c6",
  null
  
)

export default component.exports